export const fifoOnRecents = (targetStateArray: string[], actionPayload: string) => {
  if (!targetStateArray.includes(actionPayload)) {
    if (targetStateArray.length >= 3) {
      targetStateArray.shift();
    }
    targetStateArray.push(actionPayload);
  }
};
